package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_12_22_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Peers have settled the tab at the inn. The heroes question how many business expensing opportunities they missed out on. Voth Gardul meets the Heroes when they try to make their statements to the guard about Carnage Crew. The heroes hear strange whispers that they can’t localize which say that there is a missing link between the hobgoblins and Matty Footseller / Carnage Crew. After 2 hours of giving statements, the heroes are done. The heroes head to the portal. They have to descent 15 minutes into the tower basement. Before they leave, Lady Aventary gives Dirk a scroll of teleportation. When the heroes arrive on the other side of the portal, they are no longer underground but 3 stories up in a tower. Malusian Sergent Jail provisions the heroes for the journey with a horse named Flower, a 2 wheeled cart, feed, water, and rations.")
    }
}
